module.exports = {
  ach: 'ach',
  card: 'credit/debit card',
  wire: 'wire',
  blockchain: 'usdc'
};
